import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const ExpressiveXSText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text ref={ref} style={[styles.expressiveXSText, style]} {...props}>
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  expressiveXSText: {
    ...theme.typography.expressive.xs,
  },
});

export default ExpressiveXSText;
